import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  eventId() {
    return `evt_${faker.string.alphanumeric(10)}`;
  },

  integrationName() {
    return faker.helpers.arrayElement(['Lenel', 'Genetec', 'Brivo', 'Openpath']);
  },

  integrationType() {
    return faker.helpers.arrayElement(['ACCESS_GRANTED', 'ACCESS_DENIED', 'DOOR_HELD_OPEN']);
  },

  messageTimestamp() {
    return faker.date.recent({ days: 7 });
  },

  receivedAtTimestamp() {
    // Slightly after messageTimestamp to simulate network delay
    const date = new Date(this.messageTimestamp);
    date.setSeconds(date.getSeconds() + faker.number.int({ min: 1, max: 5 }));
    return date;
  },

  personEmail() {
    return faker.internet.email();
  },

  personType() {
    return faker.helpers.arrayElement(['EMPLOYEE', 'VISITOR', 'CONTRACTOR']);
  },

  eventType() {
    return faker.helpers.arrayElement(['Badge tapped', 'Signed in', 'Signed out']);
  },

  personName() {
    return faker.person.fullName();
  },

  siteId() {
    return `site_${faker.string.alphanumeric(8)}`;
  },

  deliveryAttempt() {
    return faker.number.int({ min: 1, max: 3 });
  },

  portalName() {
    return faker.helpers.arrayElement(['Main Entrance', 'Side Door', 'Garage Entry', 'Loading Dock']);
  },

  portalType() {
    return faker.helpers.arrayElement(['DOOR', 'ELEVATOR', 'TURNSTILE', 'GARAGE']);
  },

  failureReason() {
    return this.integrationType === 'ACCESS_DENIED'
      ? faker.helpers.arrayElement(['INVALID_CREDENTIALS', 'EXPIRED_ACCESS', 'OUTSIDE_SCHEDULE'])
      : null;
  },

  afterCreate(accessEvent, server) {
    // Randomly associate with an employee
    if (accessEvent.personType === 'EMPLOYEE' && !accessEvent.employee) {
      const employee = server.schema.employees.first();
      if (employee) {
        accessEvent.update({
          employeeId: employee.id,
          employee,
        });
      }
    }

    // Always associate with a location
    if (!accessEvent.location) {
      const location = server.schema.locations.first();
      if (location) {
        accessEvent.update({ location });
      }
    }
    //TODO: Add pluginInstall association after it's added as a relationship on the AccessEvent model
  },
});

// Helper function to create multiple access events
export function createAccessEvents(server, { count = 50, locationId = null, startDate = null, endDate = null } = {}) {
  const start = startDate || new Date(Date.now() - 24 * 60 * 60 * 1000); // Default to last 1 day
  const end = endDate || new Date();

  // Find the specified location or use the first one
  const location = locationId ? server.schema.locations.find(locationId) : server.schema.locations.first();

  if (!location) {
    throw new Error('No location found. Please ensure locations exist in the database or provide a valid locationId.');
  }

  const events = [];
  for (let i = 0; i < count; i++) {
    const event = server.create('access-event', {
      messageTimestamp: faker.date.between({
        from: start,
        to: end,
      }),
      location,
    });
    events.push(event);
  }

  return events;
}
